<template>
    <div class=" overflow-y: auto">
        <div
            class="flex flex-row mx-auto grid grid-cols-1 pt-6 gap-8"
        >
            <OrgPanel
                v-for="organization in organizations"
                :user="user"
                :key="organization.id"
                :organization="organization"
                :show_status="show_status"
                class="flex-1 min-w-2/5 connected-pro"
            />
        </div>
    </div>
</template>

<script>
import OrgPanel from './OrgPanel.vue';
export default {
    name: "OrgList",
    props: ['user', 'organizations', 'show_status'],
    components: {
      OrgPanel,
    },
    mounted() {
        console.log( 'org list: ');
        console.log( this.show_status);
    },
}
</script>

<style scoped>

</style>
